/**
 * The module that will contain our validation directives. AngularJS provides $validators
 * to make custom validation easy.
 *
 * @type {*|module}
 */
var ValidationDirectives = angular.module('ValidationDirectives', []);


/**
 * Extends the AngularJS $validators to validate an input field for a floating point
 * number with up to two decimals.
 *
 * Usage:
 * <input type="text" name="myFloat" ng-model="myModel.myFloat" two-decimal-number-validator />
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var twoDecimalNumberValidator = function() {
    return {
        // restrict to an attribute type.
        restrict: 'A',

        // element must have ng-model attribute.
        require: 'ngModel',

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function(scope, elem, attr, ctrl) {

            var pattern = /^\d{1,}\.?\d{0,2}?$/;

            ctrl.$validators.twoDecimalNumber = function(value) {
            
            		
                return (value === '' || value === null )? true : pattern.test(value);
            
            };

        }
    };
};
ValidationDirectives.directive("twoDecimalNumberValidator", twoDecimalNumberValidator);


/**
 * Extends the AngularJS $validators to validate an input field for valid percentage. A
 * percentage is considered valid if it is greater than zero and less than or equal to 100.
 *
 * Usage:
 * <input type="text" name="percent" ng-model="myModel.percent" percent-range-validator />
 *
 * @returns {{restrict: string, require: string, link: Function}}
 */
var percentRangeValidator = function() {
    return {
        // restrict to an attribute type.
        restrict: 'A',

        // element must have ng-model attribute.
        require: 'ngModel',

        // scope = the parent scope
        // elem = the element the directive is on
        // attr = a dictionary of attributes on the element
        // ctrl = the controller for ngModel.
        link: function(scope, elem, attr, ctrl) {

            ctrl.$validators.percentNumberLowerRange = function(value) {
                return value > 0;
            };

            ctrl.$validators.percentNumberUpperRange = function(value) {
                return value <= 100;
            };

        }
    };
};
ValidationDirectives.directive("percentRangeValidator", percentRangeValidator);

export default ValidationDirectives;